import { render } from "./TagsWindow.vue?vue&type=template&id=4d0da100"
import script from "./TagsWindow.vue?vue&type=script&lang=js"
export * from "./TagsWindow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__